export const initialAbility = [
  {
    subject: 'Auth',
    action: 'read',
  },
]

export const _ = undefined
